import React from 'react';
import Style from './StatsCard.module.scss';
import classNames from 'classnames';

interface IStatsCardProps {
  title: string;
  value: string;
  img: string;
}

const StatsCard: React.FC<IStatsCardProps> = (props) => {
  const { title, value, img } = props;

  return (
    <div className={classNames(Style['stats-card'], 'info-box')}>
      <img
        src={img}
        className={classNames(Style['icon'], 'icon')}
        width={32}
        height={32}
      />
      <p className={'title'}>{title}</p>
      <p className={'value'}>{value}</p>
    </div>
  );
};

export default StatsCard;
